import { GenericDocPage } from "#/components/docs/GenericDocPage";

type Props = {
  locale: string;
  pageId: string;
  breadcrumbs: Array<{ label: string; href?: string }>;
  lastReviewedAt: string;
  reviewedBy: string;
  title: string;
  description: string;
};

export { Page };

function Page(props: Props) {
  return <GenericDocPage {...props} />;
}
